












import { Vue, Component, Inject } from "vue-property-decorator";

// Components
import BasketItem from "@/components/app/global/baskets/basket/basketView/basketItem.vue";

// Types
import { IBasketProviderData } from "@/models/providers/baskets";

@Component({
  components: {
    BasketItem
  }
})
export default class BasketItems extends Vue {
  // Inject - Basket provider data
  @Inject({ from: "providerData" })
  public readonly $providerData!: () => IBasketProviderData;

  public get basketProducts() {
    return this.$_.get(this.$providerData(), "basket.products", []);
  }
}
